import Vue from 'vue'
// import Constants from '@/utils/Constants'

const state = {
  // グロナビのグループ表示権限
  group: {
    // サービス管理
    service: false,
    // マスタ管理
    masta: false,
    // アカウント管理
    user: false,
    // お知らせ管理
    notice: false,
    // ログ管理
    log: false,
    // ADMP管理
    admp: false,
  },

  // viewの表示権限
  view: {
    Home: false,

    // サービス管理
    Service: false,
    ServiceForm: false,
    ServiceConfirm: false,
    ServiceDetail: false,
    // サービス管理 : 配信期間設定
    ServiceDeliveryTerm: false,
    ServiceDeliveryTermDetail: false,
    // サービス管理 : 属性設定
    ServiceAttribute: false,
    ServiceAttributeDetail: false,
    // サービス管理 : 機能設定
    ServiceFunction: false,
    ServiceFunctionDetail: false,
    // サービス管理 : メルマガ設定
    ServiceMailMagazine: false,
    // サービス管理 : 連携CMS設定
    ServiceLinkedCms: false,
    // サービス管理 : RSS設定
    ServiceRss: false,
    // サービス管理 : Dropbox設定
    ServiceDropbox: false,
    // サービス管理 : コンテンツ設定
    ServiceContentsSetting: false,
    ServiceContentsSettingForm: false,
    // サービス管理 : コンテンツ画面別設定
    ServiceScreenSetting: false,
    ServiceScreenSettingForm: false,
    // サービス管理 : コンテンツ適用
    ServiceContentsApply: false,
    // サービス管理 : リンク集カテゴリ
    ServiceLinkCategory: false,

    // ファイル一覧
    File: false,
    // Bot一覧
    Bot: false,

    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
    // 外部パートナー連携管理
    Partner: false,
    PartnerForm: false,
    PartnerConfirm: false,
    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ED

    // 配信タイプマスタ
    DeliveryTypeMst: false,
    // お知らせタイプマスタ
    NoticeTypeMst: false,
    // 連携CMSマスタ
    LinkedCmsMst: false,
    // 画面構成マスタ
    ScreenConfigMst: false,
    // 固定画面マスタ
    ScreenIdMst: false,
    // スマホアプリマスタ
    SpAppMst: false,

    // アカウント管理
    User: false,
    UserForm: false,
    UserConfirm: false,

    // お知らせ管理
    Notice: false,
    NoticeSelector: false,
    NoticeForm: false,
    NoticeConfirm: false,
    NoticeDetail: false,

    // お知らせ配信管理
    NoticeList: false,
    NoticeListDetail: false,

    // ログ管理
    Log: false,
    LogDownload: false,

    // テナント管理
    Tenant: false,
    TenantDetail: false,
    // コミュニティ管理
    Community: false,
    CommunityDetail: false,
    CommunityLocation: false,
    // デバイス管理
    Device: false,
    
    // ささえiでんわ管理
    VideoChat: false,
    // マイアカウント
    MyAccount: false,
    // ロケーション管理
    Location: false,
  },

  // 機能の表示権限
  function: {
    Home: {
      overview: false,
      adminNotice: false,
      serviceAnalysis:false,
    }
  },
}

const getters = {
  get: state => key => state[key],

  permittedGroup: state => key => state.group[key],
  permittedView: state => key => state.view[key],
  permittedFunction: state => (view, key) => state.function[view][key],
}

const actions = {
  /**
   * set
   * @params permissions {Object}
   *         .isAdmin
   *         .isOperator
   */
  set ({commit}, permissions) {
    commit('set', permissions)
  },
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  /**
   * 権限を設定
   */
  set (state, {
    isAdmin,
    isOperator,
    isExternal
  }) {
    // システム管理者
    if (isAdmin) {
      // グロナビのグループ表示権限
      Object.keys(state.group)
        .forEach(key => Vue.set(state.group, key, true))
      // viewの表示権限
      Object.keys(state.view)
        .forEach(key => Vue.set(state.view, key, true))
      // 機能の表示権限
      Vue.set(state.function.Home, 'overview', true)
      Vue.set(state.function.Home, 'adminNotice', true)

    // サービス運用担当者
    } else if (isOperator) {
      // グロナビのグループ表示権限
      Vue.set(state.group, 'user', true)
      Vue.set(state.group, 'notice', true)
      Vue.set(state.group, 'log', true)
      // viewの表示権限
      Vue.set(state.view, 'Home', true)
      Vue.set(state.view, 'User', true)
      Vue.set(state.view, 'UserForm', true)
      Vue.set(state.view, 'UserConfirm', true)
      Vue.set(state.view, 'Notice', true)
      Vue.set(state.view, 'NoticeSelector', true)
      Vue.set(state.view, 'NoticeForm', true)
      Vue.set(state.view, 'NoticeConfirm', true)
      Vue.set(state.view, 'NoticeDetail', true)
      Vue.set(state.view, 'Log', true)
      Vue.set(state.view, 'LogDownload', true)
      Vue.set(state.view, 'VideoChat', false)
      if (window.localStorage.user) {
        const user = JSON.parse(window.localStorage.user);
        if (user.service) {
          Vue.set(state.view, 'VideoChat', user.service.isVideoChatEnabled)
        }
      }
      Vue.set(state.view, 'MyAccount', true)
      // 機能の表示権限
      Vue.set(state.function.Home, 'serviceAnalysis', true)
      // ロケーション管理
      Vue.set(state.view, 'Location', true)

    // 外部連携CMS担当者
    } else if (isExternal) {
      // viewの表示権限
      Vue.set(state.view, 'Home', true)
    }

    Vue.set(state.view, 'NoticeList', true)
    Vue.set(state.view, 'NoticeListDetail', true)

    console.log('permission', state)
  },

  /**
   * 権限を初期化
   */
  reset (state) {
    // グロナビのグループ表示権限
    Object.keys(state.group)
      .forEach(key => Vue.set(state.group, key, false))
    // viewの表示権限
    Object.keys(state.view)
      .forEach(key => Vue.set(state.view, key, false))
    // 機能の表示権限
    Object.keys(state.function.Home)
      .forEach(key => Vue.set(state.function.Home, key, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
